export const content = {
    title: 'A Great Place To Start\n<mark class="goldMark">Your Nomad Life<mark>',
    subtitle: 'Easily own homes overseas that give you the security, stability and income you need to become a nomad.',
    buttonCTA: 'Try It With a Free Stay',
}